import { ChevronRightRounded } from "@mui/icons-material";
import { ListItemButton, Typography } from "@mui/material";
var CalendarEvent = function (_ref) {
    var event = _ref.event;
    return /*#__PURE__*/ React.createElement(ListItemButton, {
        disableRipple: true,
        disableGutters: true,
        sx: {
            py: 0.25,
            px: 0.5,
            justifyContent: 'space-between',
            bgcolor: 'secondary.50',
            borderRadius: 1,
            mx: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        noWrap: true,
        maxWidth: 100,
        fontSize: "sm",
        fontWeight: "medium",
        color: "text.primary"
    }, event === null || event === void 0 ? void 0 : event.CustomerName), /*#__PURE__*/ React.createElement(Typography, {
        noWrap: true,
        maxWidth: 100,
        fontSize: "sm",
        color: "text.secondary",
        display: "inline-flex",
        alignItems: "center"
    }, event === null || event === void 0 ? void 0 : event.RegNo, /*#__PURE__*/ React.createElement(ChevronRightRounded, {
        fontSize: "small",
        color: "secondary"
    })));
};
export default CalendarEvent;
